import React, { useEffect, useRef, useState, useContext } from 'react';
import * as styles from './CareerBanner.module.scss';
import { gsap } from 'gsap';
import bannerImageLargeDesktop from './images/career-banner-large-desktop.jpg';
import bannerImageSmallDesktop from './images/career-banner-small-desktop.jpg';
import bannerImageTablet from './images/career-banner-tablet.jpg';
import bannerImageMobile from './images/career-banner-mobile.jpg';
import {headerWithCareerBanner} from '../../utils/headerWithCareerBanner';
import { TabFilters } from '../../AppLanding';

const { __ } = window.wp.i18n; 

interface SearchComponentProps {
    currentKeyword: string;
    onSearch: (newKeyword: string) => void;    
    onTabFilterOpen: (isOpen: boolean) => void;   
    results: (isVisible: boolean) => void;   
}

// get the filters selected in settings
interface Window {
    cg_jobs_banner_strikeout_text?: string;
    cg_jobs_banner_handwritten_text?: string;
    cg_jobs_placeholder_text?: string;
    cg_jobs_banner_image_large_desktop?: string;
    cg_jobs_banner_image_small_desktop?: string;
    cg_jobs_banner_image_tablet?: string;
    cg_jobs_banner_image_mobile?: string;
    cg_jobs_explore_all_jobs_button_text?: string;
    cg_jobs_explore_all_jobs_url?: string;
  }
  const bannerStrikeOutText = (window as Window).cg_jobs_banner_strikeout_text;
  const bannerHandWrittenText = (window as Window).cg_jobs_banner_handwritten_text;
  const placeholderText = (window as Window).cg_jobs_placeholder_text;
  const bannerbgImageLargeDesktop = (window as Window).cg_jobs_banner_image_large_desktop;
  const bannerbgImageSmallDesktop = (window as Window).cg_jobs_banner_image_small_desktop;
  const bannerbgImageTablet = (window as Window).cg_jobs_banner_image_tablet;
  const bannerbgImageMobile = (window as Window).cg_jobs_banner_image_mobile;
  const exploreAllJobsButtonText = (window as Window).cg_jobs_explore_all_jobs_button_text;
  const exploreAllJobsLink = (window as Window).cg_jobs_explore_all_jobs_url;
  

export const CareerBanner:React.FC<SearchComponentProps> = ({currentKeyword, onSearch, onTabFilterOpen, results}) => {
   const [keyword, setKeyword] = useState(currentKeyword);
   //const [isFilterClose, setIsFilterClose] = useState(true);
   const [placeholder, setPlaceholder] = useState(placeholderText ? placeholderText : `${ __( 'Search jobs by location, profession or keywords', 'cg-jobs' ) }`);
   const [isMobileScreen, setIsMobileScreen] = useState<boolean>(window.matchMedia("(max-width: 991px)").matches);
   const [isTabletScreen, setIsTabletScreen] = useState<boolean>(window.matchMedia("(max-width: 1200px)").matches);
   const inputRef = useRef<HTMLInputElement>(null);
   const tabFilters = useContext(TabFilters);
   
   const textRef = useRef<HTMLDivElement>(null);
   const svgRef = useRef<SVGPathElement>(null);
   const svgRefElement = useRef<SVGSVGElement>(null);
   const textRef2 = useRef<HTMLDivElement>(null);

  // Update `keyword` with `currentKeyword` prop
  useEffect(() => {
    setKeyword(currentKeyword);
  }, [currentKeyword]);
   
  // Effect to trigger API callback when inputValue is empty
  useEffect(() => {
      if (keyword === '') {
          onSearch(''); 
      }
  }, [keyword]);

  useEffect(() => {     
      const changeToMobileLayout = () => {   
          const wrapper = document.querySelector('#wrapper-cjs') as HTMLElement;                    

          // For mobile
          if (window.matchMedia("(min-width: 992px").matches){
              setIsMobileScreen(false);
              setPlaceholder(placeholderText ? placeholderText : `${ __( 'Search jobs by location, profession or keywords', 'cg-jobs' ) }`);                                           
              if(wrapper) wrapper.removeAttribute('style');              
          } else {
              setIsMobileScreen(true);
              setPlaceholder(placeholderText ? placeholderText : `${ __( 'Search for jobs', 'cg-jobs' ) }`);
              if(wrapper) {
                if(!tabFilters){
                  wrapper.style.gridTemplateColumns = '1fr';
                  //setIsFilterClose(true);                
                } else {
                  wrapper.removeAttribute('style');
                } 
            }           
          }

          // For tablet
          if (window.matchMedia("(min-width: 1200px").matches){
              setIsTabletScreen(false);
              //setIsFilterClose(true);
          } else {
              setIsTabletScreen(true);                
          }
                  
          headerWithCareerBanner();  
      };

      // Set the initial placeholder
      changeToMobileLayout();

      // Add an event listener for window resize
      window.addEventListener('resize', changeToMobileLayout);      

      // Cleanup event listener on component unmount
      return () => window.removeEventListener('resize', changeToMobileLayout);
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {   
    if (keyword.length >= 3) {   
      onSearch((keyword.trim()));
      results(true);        
    }        
      e.preventDefault();
  };

  const handleKeyDown = (e:React.KeyboardEvent<HTMLInputElement>) => {  
      const inputElement = e.target as HTMLInputElement; 
      const value = inputElement.value;
      // Check if the Enter key was pressed
      if (e.key === 'Enter' && value.length >= 3) {
          inputRef.current && onSearch((inputRef.current.value.trim())); 
          e.preventDefault();
          // Blur the input field
          if (inputRef.current) {
              inputRef.current.blur();
          }
      }

      if(value.length >= 3) results(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setKeyword(decodeURIComponent(value));
      
      // Trigger search if 3 or more letters are typed
      if (value.length >= 3) {
          onSearch((value.trim()));
          results(true);
      } else if (value.length === 0) {
          onSearch(''); // Clear search on empty input
          results(false);
      }
  };

  // 
  const OpenMobileFilters = () => {
      const filters = document.querySelector('.open-filters') as HTMLElement;
      filters ? filters.style.display = "block" : "";

      // Make sure modal scrolls to top when opened
      const modal = document.getElementById('offcanvasBottom');
      const modalBody = modal && modal.querySelector('.offcanvas-body');
      if (modalBody) {        
          modalBody.scrollTop = 0;   // Scroll the modal body to the top
      }
  }

  const OpenTabletFilters = () => {
      const filterWrapper = document.querySelector('#filter-wrapper') as HTMLElement;
      const filterContainer = document.querySelector('#filter-container') as HTMLElement;
      const wrapper = document.querySelector('#wrapper-cjs') as HTMLElement;
              
      if (!tabFilters) {
          filterWrapper.style.transform = 'translateX(0)';
          filterWrapper.style.opacity = '1';
          filterContainer.style.display = 'block';
          wrapper.style.gridTemplateColumns = '2.99fr 1.01fr';
      } else {
          filterWrapper.style.transform = 'translateX(100%)';
          filterWrapper.style.opacity = '0';         
          filterContainer.style.display = 'none';  
          wrapper.style.gridTemplateColumns = '1fr';
      }
      //setIsFilterClose(!isFilterClose);
      onTabFilterOpen(!tabFilters);
  }
 
  // To Animate text
  useEffect(() => {
    const animateText = () => { 
      if(textRef.current) textRef.current.style.opacity = '0';  
      if(svgRefElement.current) svgRefElement.current.style.opacity = '0';  

      // Animation for the handwritten text
      if (textRef.current) {
        const text = textRef.current;
        const textContent = text.innerText;

        //Hide the original text and create an empty span for each letter
        text.innerHTML = '';
        textContent.split('').forEach((char, index) => {
          const span = document.createElement('span');
          span.innerText = char;
          text.appendChild(span);
        });

        //Animate the text
        gsap.delayedCall(1, () => {
          gsap.fromTo(
            text,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              duration: 1,
            }
          );
        })


        // After the text is written, draw the line-through SVG path
        gsap.delayedCall(1.5, () => {
          if (svgRef.current) {
            svgRefElement.current && (svgRefElement.current.style.opacity = '1');
            gsap.to(svgRef.current, {
              strokeDashoffset: 0,
              duration: 2,
              ease: 'power2.out',
            });
          }
        });
      }      

      if (textRef2.current) {
        const text = textRef2.current;
        const textContent = text.innerText;

        // Hide the original text and create an empty span for each letter
        text.innerHTML = '';
        textContent.split('').forEach((char, index) => {
          const span = document.createElement('span');
          span.innerText = char;
          text.appendChild(span);
        });

        // Animate the text
        gsap.delayedCall(2, () => {
          text.style.opacity = '1';
          gsap.fromTo(
            text.querySelectorAll('span'),
            {
              opacity: 0,
              x: -10,
            },
            {
              opacity: 1,
              x: 0,
              stagger: 0.1, // Stagger the animation for each letter
              duration: 0.2,
            }
          );
        });
      }
    };
  
    // Run animation on mount
    animateText();

    // Run animation on resize
    const handleResize = () => {
      animateText();
    };

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Cleanup the resize event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const content = document.querySelector('#cg-jobs-search-root-landing') as HTMLElement;
  if(content) content.style.overflowX = 'clip';

  // Banner Images from settings or default images
  const heroLargeDesktopImgURL = bannerbgImageLargeDesktop ? bannerbgImageLargeDesktop : bannerImageLargeDesktop;
  const heroSmallDesktopImgURL = bannerbgImageSmallDesktop ? bannerbgImageSmallDesktop : bannerImageSmallDesktop;
  const heroTabImgURL = bannerbgImageTablet ? bannerbgImageTablet : bannerImageTablet;
  const heroMobImgURL = bannerbgImageMobile ? bannerbgImageMobile : bannerImageMobile;

  return (
    <>
        <div className={styles['career-banner']} id="career-banner">
            <div className={styles['banner-image-wrapper']}>           
              <picture>
                <source srcSet={`${heroLargeDesktopImgURL}?w=2880&quality=70 1x, ${heroLargeDesktopImgURL}?w=2880&quality=70 2x`} media="(min-width: 1728px)"/>
                <source srcSet={`${heroSmallDesktopImgURL}?w=1728&quality=70 1x, ${heroSmallDesktopImgURL}?w=2880&quality=70 2x`} media="(min-width: 1200px)"/>
                <source srcSet={`${heroTabImgURL}?w=1024&quality=70 1x, ${heroTabImgURL}?w=1536&quality=70 2x`} media="(min-width: 992px)"/>
                <source srcSet={`${heroMobImgURL}?w=430&quality=70 1x, ${heroMobImgURL}?w=1152&quality=70 2x`} media="(min-width: 0)"/>
                <img width={'100%'} height={'100%'} className="lazy" src={heroLargeDesktopImgURL} data-sizes="auto" loading="lazy" alt="" />                
              </picture>
            </div>
        
            <div className={[styles['banner-content'], styles['container-cjs'], 'container'].join(" ")}>
                {isMobileScreen ? 
                  <div className={styles['rewrite-mobile']}>
                      {bannerHandWrittenText ? bannerHandWrittenText : "Rewrite your future"}
                  </div>                 
                : <>
                  <h1>
                    <div style={{ position: 'relative', display: 'inline-block', textAlign: 'left' }}>                      
                      <div className={styles['line-through-text']} ref={textRef}>
                        {bannerStrikeOutText ? bannerStrikeOutText : "Wait for change"}
                      </div>

                      {/* SVG line-through animation */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 500 100"
                        className={styles['svgLine']}
                        ref={svgRefElement}
                      >
                        <path
                          ref={svgRef}
                          //d="M0,25 C150,10 200,40 250,25 C300,10 350,40 380,25"
                          d="M0,20 C150,15 200,25 250,25 C300,18 350,25 390,25"
                          fill="transparent"
                          stroke="white"
                          strokeWidth="3"
                          strokeDasharray="800"
                          strokeDashoffset="800"
                        />
                      </svg>
                      
                      <div className={styles['rewrite']} ref={textRef2} style={{  }}>
                            {bannerHandWrittenText ? bannerHandWrittenText : "Rewrite your future"}
                      </div>
                    </div>
                  </h1>
                  <a href={exploreAllJobsLink} className={styles['explore-link']}>{exploreAllJobsButtonText ? exploreAllJobsButtonText : 'Explore all jobs'}</a>
                  <div className={styles['search-container']}>                   
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <input
                            type="text"
                            value={keyword}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            onFocus={(e) => {
                                setPlaceholder("");
                                e.target.select();
                            }}     
                            onBlur={() => setPlaceholder(placeholderText ? placeholderText : `${ __( 'Search jobs by location, profession or keywords', 'cg-jobs' ) }`)}         
                            placeholder={placeholder}
                            aria-label={placeholder}
                        />
                        <button type="submit">{ __( 'Search', 'cg-jobs' ) }</button>
                    </form>
                  </div>   
                </> 
                }                             
            </div>
        </div>
        { isTabletScreen && 
          <div className={styles['mobile-container']}>
              <div className={styles['search-container']}>
                  <form onSubmit={(e) => handleSubmit(e)}>                   
                      <input
                          type="text"
                          ref={inputRef}
                          value={keyword}
                          onChange={handleChange}  
                          onFocus={(e) => {
                              setPlaceholder("");
                              e.target.select();
                          }}     
                          onKeyDown={handleKeyDown}
                          onBlur={() => setPlaceholder(placeholderText ? placeholderText : `${ __( 'Search for jobs', 'cg-jobs' ) }`)}                 
                          placeholder= {placeholder}
                          aria-label={placeholder}
                      />
                  </form>
                  { isMobileScreen ? 
                    <button type='button' data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" className={styles['open-mobile-filter']} onClick={OpenMobileFilters} aria-label='filter toggle' disabled={keyword.length === 0}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.0394 17.6165L19.0175 17.6165C19.2724 17.6165 19.5168 17.5153 19.697 17.3351C19.8773 17.1548 19.9785 16.9104 19.9785 16.6555C19.9785 16.4006 19.8773 16.1562 19.697 15.976C19.5168 15.7958 19.2724 15.6945 19.0175 15.6945L14.0394 15.6945C13.8374 15.1379 13.4689 14.657 12.9841 14.3172C12.4992 13.9774 11.9215 13.7951 11.3294 13.7951C10.7373 13.7951 10.1595 13.9774 9.67464 14.3172C9.18977 14.657 8.82129 15.1379 8.61928 15.6945L1.71917 15.6945C1.4643 15.6945 1.21986 15.7957 1.03963 15.976C0.859403 16.1562 0.758155 16.4006 0.758155 16.6555C0.758155 16.9104 0.859403 17.1548 1.03963 17.3351C1.21986 17.5153 1.4643 17.6165 1.71917 17.6165L8.61928 17.6165C8.82129 18.1731 9.18977 18.654 9.67464 18.9938C10.1595 19.3337 10.7373 19.516 11.3294 19.516C11.9215 19.516 12.4992 19.3337 12.9841 18.9938C13.4689 18.654 13.8374 18.1731 14.0394 17.6165ZM10.3683 16.6555C10.3683 16.4654 10.4247 16.2796 10.5303 16.1216C10.6359 15.9636 10.786 15.8404 10.9616 15.7677C11.1372 15.6949 11.3304 15.6759 11.5168 15.713C11.7033 15.75 11.8745 15.8416 12.0089 15.976C12.1433 16.1104 12.2348 16.2816 12.2719 16.468C12.309 16.6545 12.29 16.8477 12.2172 17.0233C12.1445 17.1989 12.0213 17.349 11.8633 17.4546C11.7052 17.5602 11.5194 17.6165 11.3294 17.6165C11.0745 17.6165 10.83 17.5153 10.6498 17.3351C10.4696 17.1548 10.3683 16.9104 10.3683 16.6555ZM8.27331 10.8894L19.0175 10.8894C19.2724 10.8894 19.5168 10.7882 19.697 10.6079C19.8773 10.4277 19.9785 10.1833 19.9785 9.92839C19.9785 9.67352 19.8773 9.42908 19.697 9.24885C19.5168 9.06863 19.2724 8.96738 19.0175 8.96738L8.27331 8.96738C8.0713 8.4108 7.70283 7.92992 7.21796 7.59009C6.73309 7.25025 6.15535 7.06795 5.56324 7.06795C4.97114 7.06795 4.3934 7.25025 3.90853 7.59009C3.42366 7.92992 3.05518 8.4108 2.85318 8.96738L1.71917 8.96738C1.4643 8.96738 1.21986 9.06863 1.03963 9.24885C0.859403 9.42908 0.758155 9.67352 0.758155 9.92839C0.758155 10.1833 0.859403 10.4277 1.03963 10.6079C1.21986 10.7882 1.4643 10.8894 1.71917 10.8894L2.85318 10.8894C3.05518 11.446 3.42366 11.9269 3.90853 12.2667C4.3934 12.6065 4.97114 12.7888 5.56324 12.7888C6.15535 12.7888 6.73309 12.6065 7.21796 12.2667C7.70283 11.9269 8.0713 11.446 8.27331 10.8894ZM4.60223 9.92839C4.60223 9.73832 4.65859 9.55252 4.76419 9.39448C4.86978 9.23644 5.01988 9.11327 5.19548 9.04053C5.37108 8.96779 5.56431 8.94876 5.75073 8.98584C5.93715 9.02292 6.10839 9.11445 6.24279 9.24885C6.37719 9.38325 6.46872 9.55449 6.5058 9.74091C6.54288 9.92733 6.52385 10.1206 6.45111 10.2962C6.37837 10.4718 6.2552 10.6219 6.09716 10.7275C5.93912 10.833 5.75332 10.8894 5.56324 10.8894C5.30837 10.8894 5.06393 10.7882 4.8837 10.6079C4.70348 10.4277 4.60223 10.1833 4.60223 9.92839ZM15.9615 4.16229L19.0175 4.16229C19.2724 4.16229 19.5168 4.06104 19.697 3.88081C19.8773 3.70058 19.9785 3.45615 19.9785 3.20127C19.9785 2.94639 19.8773 2.70195 19.697 2.52173C19.5168 2.3415 19.2724 2.24025 19.0175 2.24025L15.9615 2.24025C15.7594 1.68367 15.391 1.20279 14.9061 0.862959C14.4212 0.523125 13.8435 0.34082 13.2514 0.34082C12.6593 0.34082 12.0815 0.523125 11.5967 0.862959C11.1118 1.20279 10.7433 1.68367 10.5413 2.24025L1.71917 2.24025C1.4643 2.24025 1.21986 2.3415 1.03963 2.52173C0.859404 2.70195 0.758156 2.94639 0.758156 3.20127C0.758156 3.45615 0.859403 3.70058 1.03963 3.88081C1.21986 4.06104 1.4643 4.16229 1.71917 4.16229L10.5413 4.16229C10.7433 4.71886 11.1118 5.19974 11.5967 5.53958C12.0815 5.87941 12.6593 6.06172 13.2514 6.06172C13.8435 6.06172 14.4212 5.87941 14.9061 5.53958C15.391 5.19974 15.7594 4.71886 15.9615 4.16229ZM12.2904 3.20127C12.2904 3.0112 12.3467 2.82539 12.4523 2.66735C12.5579 2.50932 12.708 2.38614 12.8836 2.3134C13.0592 2.24067 13.2525 2.22163 13.4389 2.25872C13.6253 2.2958 13.7965 2.38732 13.9309 2.52173C14.0653 2.65613 14.1569 2.82736 14.1939 3.01378C14.231 3.2002 14.212 3.39343 14.1393 3.56903C14.0665 3.74464 13.9433 3.89473 13.7853 4.00033C13.6273 4.10592 13.4415 4.16229 13.2514 4.16229C12.9965 4.16229 12.7521 4.06104 12.5718 3.88081C12.3916 3.70058 12.2904 3.45615 12.2904 3.20127Z" fill="#F2F2F2"/>
                      </svg>               
                    </button>
                   :                                                                          
                    <button type='button' className={styles['open-filter']} onClick={OpenTabletFilters} disabled={keyword.length === 0}>               
                          { !tabFilters ? 
                              <>
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14.0394 17.6165L19.0175 17.6165C19.2724 17.6165 19.5168 17.5153 19.697 17.3351C19.8773 17.1548 19.9785 16.9104 19.9785 16.6555C19.9785 16.4006 19.8773 16.1562 19.697 15.976C19.5168 15.7958 19.2724 15.6945 19.0175 15.6945L14.0394 15.6945C13.8374 15.1379 13.4689 14.657 12.9841 14.3172C12.4992 13.9774 11.9215 13.7951 11.3294 13.7951C10.7373 13.7951 10.1595 13.9774 9.67464 14.3172C9.18977 14.657 8.82129 15.1379 8.61928 15.6945L1.71917 15.6945C1.4643 15.6945 1.21986 15.7957 1.03963 15.976C0.859403 16.1562 0.758155 16.4006 0.758155 16.6555C0.758155 16.9104 0.859403 17.1548 1.03963 17.3351C1.21986 17.5153 1.4643 17.6165 1.71917 17.6165L8.61928 17.6165C8.82129 18.1731 9.18977 18.654 9.67464 18.9938C10.1595 19.3337 10.7373 19.516 11.3294 19.516C11.9215 19.516 12.4992 19.3337 12.9841 18.9938C13.4689 18.654 13.8374 18.1731 14.0394 17.6165ZM10.3683 16.6555C10.3683 16.4654 10.4247 16.2796 10.5303 16.1216C10.6359 15.9636 10.786 15.8404 10.9616 15.7677C11.1372 15.6949 11.3304 15.6759 11.5168 15.713C11.7033 15.75 11.8745 15.8416 12.0089 15.976C12.1433 16.1104 12.2348 16.2816 12.2719 16.468C12.309 16.6545 12.29 16.8477 12.2172 17.0233C12.1445 17.1989 12.0213 17.349 11.8633 17.4546C11.7052 17.5602 11.5194 17.6165 11.3294 17.6165C11.0745 17.6165 10.83 17.5153 10.6498 17.3351C10.4696 17.1548 10.3683 16.9104 10.3683 16.6555ZM8.27331 10.8894L19.0175 10.8894C19.2724 10.8894 19.5168 10.7882 19.697 10.6079C19.8773 10.4277 19.9785 10.1833 19.9785 9.92839C19.9785 9.67352 19.8773 9.42908 19.697 9.24885C19.5168 9.06863 19.2724 8.96738 19.0175 8.96738L8.27331 8.96738C8.0713 8.4108 7.70283 7.92992 7.21796 7.59009C6.73309 7.25025 6.15535 7.06795 5.56324 7.06795C4.97114 7.06795 4.3934 7.25025 3.90853 7.59009C3.42366 7.92992 3.05518 8.4108 2.85318 8.96738L1.71917 8.96738C1.4643 8.96738 1.21986 9.06863 1.03963 9.24885C0.859403 9.42908 0.758155 9.67352 0.758155 9.92839C0.758155 10.1833 0.859403 10.4277 1.03963 10.6079C1.21986 10.7882 1.4643 10.8894 1.71917 10.8894L2.85318 10.8894C3.05518 11.446 3.42366 11.9269 3.90853 12.2667C4.3934 12.6065 4.97114 12.7888 5.56324 12.7888C6.15535 12.7888 6.73309 12.6065 7.21796 12.2667C7.70283 11.9269 8.0713 11.446 8.27331 10.8894ZM4.60223 9.92839C4.60223 9.73832 4.65859 9.55252 4.76419 9.39448C4.86978 9.23644 5.01988 9.11327 5.19548 9.04053C5.37108 8.96779 5.56431 8.94876 5.75073 8.98584C5.93715 9.02292 6.10839 9.11445 6.24279 9.24885C6.37719 9.38325 6.46872 9.55449 6.5058 9.74091C6.54288 9.92733 6.52385 10.1206 6.45111 10.2962C6.37837 10.4718 6.2552 10.6219 6.09716 10.7275C5.93912 10.833 5.75332 10.8894 5.56324 10.8894C5.30837 10.8894 5.06393 10.7882 4.8837 10.6079C4.70348 10.4277 4.60223 10.1833 4.60223 9.92839ZM15.9615 4.16229L19.0175 4.16229C19.2724 4.16229 19.5168 4.06104 19.697 3.88081C19.8773 3.70058 19.9785 3.45615 19.9785 3.20127C19.9785 2.94639 19.8773 2.70195 19.697 2.52173C19.5168 2.3415 19.2724 2.24025 19.0175 2.24025L15.9615 2.24025C15.7594 1.68367 15.391 1.20279 14.9061 0.862959C14.4212 0.523125 13.8435 0.34082 13.2514 0.34082C12.6593 0.34082 12.0815 0.523125 11.5967 0.862959C11.1118 1.20279 10.7433 1.68367 10.5413 2.24025L1.71917 2.24025C1.4643 2.24025 1.21986 2.3415 1.03963 2.52173C0.859404 2.70195 0.758156 2.94639 0.758156 3.20127C0.758156 3.45615 0.859403 3.70058 1.03963 3.88081C1.21986 4.06104 1.4643 4.16229 1.71917 4.16229L10.5413 4.16229C10.7433 4.71886 11.1118 5.19974 11.5967 5.53958C12.0815 5.87941 12.6593 6.06172 13.2514 6.06172C13.8435 6.06172 14.4212 5.87941 14.9061 5.53958C15.391 5.19974 15.7594 4.71886 15.9615 4.16229ZM12.2904 3.20127C12.2904 3.0112 12.3467 2.82539 12.4523 2.66735C12.5579 2.50932 12.708 2.38614 12.8836 2.3134C13.0592 2.24067 13.2525 2.22163 13.4389 2.25872C13.6253 2.2958 13.7965 2.38732 13.9309 2.52173C14.0653 2.65613 14.1569 2.82736 14.1939 3.01378C14.231 3.2002 14.212 3.39343 14.1393 3.56903C14.0665 3.74464 13.9433 3.89473 13.7853 4.00033C13.6273 4.10592 13.4415 4.16229 13.2514 4.16229C12.9965 4.16229 12.7521 4.06104 12.5718 3.88081C12.3916 3.70058 12.2904 3.45615 12.2904 3.20127Z" fill="#F2F2F2"/>
                                  </svg> { __( 'Filter', 'cg-jobs' ) } 
                              </>
                              : 
                              <>
                                  <svg width="11" height="11" viewBox="0 0 14 15" fill="none" className={styles['close-icon']} xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12.7201 13.0677L1.06445 1.65234" stroke="white" stroke-width="2.0373" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M1.06445 13.0677L12.7201 1.65234" stroke="white" stroke-width="2.0373" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg> { __( 'Close Filter', 'cg-jobs' ) }
                              </>
                          }                       
                      </button>                                    
                  }
              </div>
          </div>
        }
    </>
  )
}